import { AppRouter } from './Routes'
import './App.css'
import { store } from 'app/store'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { updatePtr } from 'features/Home/homePage.slice'
import { useIdleTimer } from 'react-idle-timer'
import { useLogoutMutation } from 'Services/API/authentication.api'
import { pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`;

function App() {
  const navigate = useNavigate()
  const isLoggedIn = useAppSelector((state) => state.user.isLoggedIn)
  const [logout] = useLogoutMutation()
  const onIdle = () => {
    if (isLoggedIn) {
      logout(null)
      navigate('/')
    }
  }
  const minutes = 15
  const idleTimer = useIdleTimer({
    timeout: minutes * 1000 * 60,
    onIdle: onIdle,
    debounce: 500,
  })

  const [serachParams] = useSearchParams()
  const dispatch = useAppDispatch()

  useEffect(() => {
    idleTimer.reset()

    const ptr = serachParams.get('ptr')
    if (ptr) {
      dispatch(updatePtr(ptr))
    }
  }, [])

  return <AppRouter />
}

export default App
